<template>
  <div class="wrapper">
    <upload
      listType="picture-card"
      class="avatar-uploader"
      :showUploadList="false"
      :action="action"
      @change="handleChange"
    >
      <img v-if="base64Preview" :src="base64Preview" alt="avatar" />
      <img v-else-if="currentUrl" :src="currentUrl" />
      <div class="input-placeholder" v-else>
        <a-icon :type="loading ? 'loading' : 'user'" />
        <strong class="add-photo-label">Dodaj zdjęcie</strong>
      </div>
    </upload>
    <div class="buttons">
      <a-button
        v-if="value || currentUrl"
        type="link"
        icon="delete"
        class="remove-button"
        @click="removeImage"
      >
        Usuń zdjęcie
      </a-button>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      loading: false,
      base64Preview: ''
    }
  },
  props: {
    value: {
      type: [String]
    },
    currentUrl: {
      type: String,
      required: false
    },
    action: {
      type: String,
      required: true
    }
  },
  methods: {
    removeImage() {
      this.$emit('removeImage')
      this.$emit('input', null)
      this.base64Preview = ''
    },
    handleChange(info) {
      if (info.file.status === 'uploading') {
        this.loading = true
        return
      }
      if (info.file.status === 'done') {
        this.$emit('input', info.file.response.name)
        // Get this url from response in real world.
        this.getBase64(info.file.originFileObj, imageUrl => {
          this.base64Preview = imageUrl
          this.loading = false
        })
      }
    },
    getBase64(img, callback) {
      const reader = new FileReader()
      reader.addEventListener('load', () => callback(reader.result))
      reader.readAsDataURL(img)
    }
  }
}
</script>
<style lang="scss" scoped>
.wrapper {
  text-align: center;
}

.add-photo-label {
  display: block;
  margin-top: 4px;
  color: rgba(black, 0.45);
}

.title {
  margin-bottom: 12px;
}

.buttons {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.avatar-uploader ::v-deep .ant-upload {
  padding: 8px;
}

.avatar-uploader img {
  max-width: 75%;
  max-height: 196px;
  border-radius: 12px;
}

::v-deep .ant-upload-select-picture-card {
  margin-bottom: 4px;
}

.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card {
  padding-bottom: 100%;
}

.remove-button {
  font-size: 14px;
  color: #ff4d4f;
  text-align: center;
}

.input-placeholder {
  padding: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  .anticon {
    display: flex;
    justify-content: center;
    align-items: center;

    width: 56px;
    height: 56px;
    font-size: 24px;
    background-color: rgba(black, 0.04);
    border-radius: 12px;
    margin-bottom: 8px;
  }
}
</style>
